export enum LayoutClasses {
  layout3Col = 'owc-nba--3-col',
  layout4Col = 'owc-nba--4-col',
  layout5pCol = 'owc-nba--5p-col',
}
